/* TALACHA — Crew Bundle product section behaviour.
   Reads config + variants from JSON script tags inside each .tcb section. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var amount = cents / 100;
    var plain = String(format || '${{amount}}').replace(/<[^>]*>/g, '');
    return plain.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key.indexOf('no_decimals') !== -1) {
        var whole = Math.round(amount).toLocaleString('en-US');
        return key.indexOf('comma') !== -1 ? whole.replace(/,/g, '.') : whole;
      }
      var fixed = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (key.indexOf('comma') !== -1) return fixed.replace(/,/g, '#').replace('.', ',').replace(/#/g, '.');
      return fixed;
    });
  }

  function init(root) {
    var config = JSON.parse(root.querySelector('[data-tcb-config]').textContent);
    var variants = JSON.parse(root.querySelector('[data-tcb-variants]').textContent);
    var form = root.querySelector('form.tcb__form');
    var idInput = form.querySelector('input[name="id"]');
    var fieldsets = Array.prototype.slice.call(root.querySelectorAll('[data-tcb-option]'));
    var atcButtons = Array.prototype.slice.call(root.querySelectorAll('[data-tcb-atc]'));
    var priceEls = root.querySelectorAll('[data-tcb-price]');
    var compareEl = root.querySelector('[data-tcb-compare]');
    var saveEl = root.querySelector('[data-tcb-save]');
    var mainImg = root.querySelector('.tcb__main-img');
    var errorEl = root.querySelector('[data-tcb-error]');
    var drawer = root.querySelector('[data-tcb-drawer]');
    var upsells = Array.prototype.slice.call(root.querySelectorAll('[data-tcb-upsell]'));
    var drawerShown = false;
    var lastFocus = null;
    var money = function (c) { return formatMoney(c, config.moneyFormat); };

    function selected() {
      return fieldsets.map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < opts.length; j++) { if (v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }

    function markAvailability(opts) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var trial = opts.slice();
          trial[idx] = input.value;
          var v = findVariant(trial);
          input.closest('.tcb__value').classList.toggle('is-unavailable', !v || !v.available);
        });
        var label = fs.querySelector('[data-tcb-selected]');
        if (label) label.textContent = opts[idx] || '';
      });
    }

    function setButtons(text, disabled) {
      atcButtons.forEach(function (b) {
        b.disabled = disabled;
        var t = b.querySelector('[data-tcb-atc-text]');
        if (t) t.textContent = text;
      });
    }

    function upsellTotal() {
      return upsells.reduce(function (sum, cb) {
        return cb.checked ? sum + Number(cb.dataset.price || 0) : sum;
      }, 0);
    }

    function refreshDrawerSum(variant) {
      var sumEl = root.querySelector('[data-tcb-drawer-total]');
      if (sumEl && variant) sumEl.textContent = money(variant.price + upsellTotal());
      var count = upsells.filter(function (cb) { return cb.checked; }).length;
      var countEl = root.querySelector('[data-tcb-addons-count]');
      if (countEl) countEl.textContent = count ? '(' + count + ' added)' : '';
    }

    function update(pushUrl) {
      var opts = selected();
      var v = findVariant(opts);
      markAvailability(opts);
      errorEl.textContent = '';
      if (!v) {
        idInput.value = '';
        setButtons(config.strings.unavailable, true);
        return;
      }
      idInput.value = v.id;
      priceEls.forEach(function (el) { el.textContent = money(v.price); });
      var compare = Math.max(config.separateTotal || 0, v.compare_at_price || 0);
      if (compareEl && saveEl) {
        var show = compare > v.price;
        compareEl.hidden = !show;
        saveEl.hidden = !show;
        if (show) {
          compareEl.textContent = money(compare);
          saveEl.textContent = config.strings.save.replace('[amount]', money(compare - v.price));
        }
      }
      if (v.available) setButtons(config.strings.add, false);
      else setButtons(config.strings.soldOut, true);
      if (mainImg && v.featured_image && v.featured_image.src) {
        mainImg.src = v.featured_image.src;
        mainImg.removeAttribute('srcset');
        mainImg.alt = v.featured_image.alt || v.name || '';
      }
      refreshDrawerSum(v);
      if (pushUrl && window.history && !config.preview) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    function openDrawer() {
      if (!drawer) return;
      lastFocus = document.activeElement;
      drawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      drawerShown = true;
      refreshDrawerSum(findVariant(selected()));
      var first = drawer.querySelector('.tcb-drawer__close');
      if (first) first.focus();
    }

    function closeDrawer() {
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { drawer.hidden = true; }, 280);
      if (lastFocus) lastFocus.focus();
    }

    function addToCart() {
      var v = findVariant(selected());
      if (!v || !v.available) return;
      var items = [{ id: v.id, quantity: 1 }];
      upsells.forEach(function (cb) {
        if (cb.checked && cb.value) items.push({ id: Number(cb.value), quantity: 1 });
      });
      setButtons(config.strings.adding, true);
      var drawerCta = root.querySelector('[data-tcb-drawer-cta]');
      if (drawerCta) drawerCta.disabled = true;

      if (config.preview) {
        window.alert('Preview only — this would add:\n' + JSON.stringify(items, null, 2));
        setButtons(config.strings.add, false);
        if (drawerCta) drawerCta.disabled = false;
        return;
      }

      fetch(config.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          return res.json().then(function (body) { return { ok: res.ok, body: body }; });
        })
        .then(function (r) {
          if (!r.ok) throw new Error(r.body.description || r.body.message || config.strings.error);
          window.location.href = config.cartUrl;
        })
        .catch(function (err) {
          closeDrawer();
          errorEl.textContent = err.message || config.strings.error;
          setButtons(config.strings.add, false);
          if (drawerCta) drawerCta.disabled = false;
        });
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', function () { update(true); }); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (upsells.length && config.drawerOnAdd && !drawerShown) { openDrawer(); return; }
      addToCart();
    });

    root.querySelectorAll('[data-tcb-sticky-atc]').forEach(function (b) {
      b.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    });

    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target.closest('[data-tcb-drawer-close]')) closeDrawer();
      });
      drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
      var cta = drawer.querySelector('[data-tcb-drawer-cta]');
      if (cta) cta.addEventListener('click', addToCart);
      var skip = drawer.querySelector('[data-tcb-drawer-skip]');
      if (skip) skip.addEventListener('click', function () {
        upsells.forEach(function (cb) { cb.checked = false; });
        addToCart();
      });
    }
    var openBtn = root.querySelector('[data-tcb-open-drawer]');
    if (openBtn) openBtn.addEventListener('click', openDrawer);

    upsells.forEach(function (cb) {
      cb.addEventListener('change', function () { refreshDrawerSum(findVariant(selected())); });
      var sel = cb.closest('.tcb-up').querySelector('select');
      if (sel) sel.addEventListener('change', function () {
        var opt = sel.options[sel.selectedIndex];
        cb.value = sel.value;
        cb.dataset.price = opt.dataset.price;
        var p = cb.closest('.tcb-up').querySelector('.tcb-up__price');
        if (p) p.textContent = money(Number(opt.dataset.price));
        refreshDrawerSum(findVariant(selected()));
      });
    });

    root.querySelectorAll('[data-tcb-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = t.dataset.full;
        mainImg.removeAttribute('srcset');
        mainImg.alt = t.dataset.alt || '';
        root.querySelectorAll('[data-tcb-thumb]').forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
      });
    });

    var sticky = root.querySelector('[data-tcb-sticky]');
    var mainAtc = root.querySelector('.tcb__form [data-tcb-atc]');
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainAtc);
    }

    update(false);
  }

  function boot() { document.querySelectorAll('.tcb').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
